import type { FormFields } from '../../../models/newSupportCall';
import { F2_FORM_SUBJECTS } from '../constants';

export type RequiredFieldRule = {
    field: keyof FormFields;
    message: string;
};

export type TasAdditionalFieldKey =
    | 'partOrComponentName'
    | 'partNumber'
    | 'customerComment'
    | 'problemDescription'
    | 'diagnosticAndResults'
    | 'problemSteps'
    | 'failureFrequency';

export type TasAdditionalField = {
    field: TasAdditionalFieldKey;
    label: string;
    inputType: 'input' | 'textarea';
};

const partOrComponentNameField: TasAdditionalField = {
    field: 'partOrComponentName',
    label: 'Nome da Peça ou Componente',
    inputType: 'input',
};

const partNumberField: TasAdditionalField = {
    field: 'partNumber',
    label: 'Nº da peça VW/MAN',
    inputType: 'input',
};

const customerCommentField: TasAdditionalField = {
    field: 'customerComment',
    label: 'Qual a reclamação do cliente?',
    inputType: 'textarea',
};

const problemDescriptionField: TasAdditionalField = {
    field: 'problemDescription',
    label: 'O que aconteceu?',
    inputType: 'textarea',
};

const diagnosticAndResultsField: TasAdditionalField = {
    field: 'diagnosticAndResults',
    label: 'Relate procedimentos de diagnóstico e resultados',
    inputType: 'textarea',
};

const problemStepsField: TasAdditionalField = {
    field: 'problemSteps',
    label: 'É possível reproduzir? Informe o passo-a-passo.',
    inputType: 'textarea',
};

const failureFrequencyField: TasAdditionalField = {
    field: 'failureFrequency',
    label: 'Em qual frequência a falha ocorre?',
    inputType: 'textarea',
};

const tasCommonFields: TasAdditionalField[] = [partOrComponentNameField, partNumberField];

export const getTasAdditionalFields = (subject: string): TasAdditionalField[] => {
    if (F2_FORM_SUBJECTS.includes(subject)) {
        return [...tasCommonFields, customerCommentField, problemStepsField, diagnosticAndResultsField];
    }

    if (subject === 'CABIN') {
        return [...tasCommonFields, customerCommentField, problemDescriptionField, diagnosticAndResultsField];
    }

    if (subject === 'EXHAUST_SYSTEM_AND_AFTER_TREATMENT') {
        return [...tasCommonFields, customerCommentField, diagnosticAndResultsField];
    }

    if (subject === 'SOFTWARE_DIESEL_VEHICLE') {
        return [
            ...tasCommonFields,
            customerCommentField,
            failureFrequencyField,
            problemStepsField,
            diagnosticAndResultsField,
        ];
    }

    if (subject === 'ENGINE_REPLACEMENT_REQUEST' || subject === 'TAS_DIAGNOSIS_TOOLS') {
        return [...tasCommonFields, problemDescriptionField, diagnosticAndResultsField];
    }

    if (subject === 'SOFTWARE_IDLE_AUTO_SHUTDOWN') {
        return [...tasCommonFields, customerCommentField];
    }

    return [];
};

export const getTasAdditionalRequiredFields = (subject: string): RequiredFieldRule[] =>
    getTasAdditionalFields(subject).map(field => ({
        field: field.field,
        message: `${field.label} é obrigatório`,
    }));

export const isTasSupportSubject = (subject: string) => getTasAdditionalFields(subject).length > 0;
